'use client'

import type { UserContext } from '@/lib/auth/token'
import { usePostHog } from 'posthog-js/react'
import { type ReactNode, createContext, useContext, useEffect } from 'react'

const CurrentUserContext = createContext<UserContext>({} as UserContext)

export const CurrentUserProvider = ({
	userContext,
	children,
}: { children: ReactNode; userContext: UserContext }) => {
	const posthog = usePostHog()

	useEffect(() => {
		if (!posthog) return

		posthog.reset()
		posthog.identify(userContext.userId, {
			email: userContext.email,
			name: userContext.name,
		})
		posthog.createPersonProfile()
	}, [userContext, posthog])

	return (
		<CurrentUserContext.Provider value={userContext}>
			{children}
		</CurrentUserContext.Provider>
	)
}

export const useCurrentUser = () => {
	const context = useContext(CurrentUserContext)

	return context
}
